export default __webpack_public_path__ + "static/media/sub_page_directions_en.e120b274.svg";